export default __webpack_public_path__ + "static/media/leftLantern.87d9c05e.gif";